export const prepareAppointmentRescheduleSuccessUrl = (successUrl: string, slot?: string): string => {
  if (slot) {
    const selectedSlot = slot.split('T')
    return successUrl
      .replace('{treatmentDate}', selectedSlot[0])
      .replace('{treatmentTime}', selectedSlot[1])
      .replace('{treatment}', '')
      .replace('{practitioner}', '')
  }
  return successUrl
}
